import { Link } from 'react-router-dom';

const ServiceHero = () => {
  return (
    <section className="relative h-96 flex items-center justify-center">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/c94723f5917bc9cf6112022b43cda4b1.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <nav className="flex items-center justify-center gap-2 text-sm text-white/80 mb-6">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white font-medium">Services</span>
        </nav>

        <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-['Playfair_Display']">
          Professional Auto Services
        </h1>
        <p className="text-xl text-white/95 max-w-2xl mx-auto">
          Comprehensive repair and maintenance for all makes and models in Brooklyn, New York
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:+16319337887"
            className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-full text-lg font-bold transition-all hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Call (631) 933-7887
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
